import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocationContextService } from '../../../../client/app/location-context/location-context.service';
import { IMenuItem } from '../navigation.model';
import { NavigationService } from '../navigation.service';

@Component({
    selector: 'app-footer-menu',
    templateUrl: './footer-menu.component.html',
    styleUrls: ['./footer-menu.component.scss']
})
export class FooterMenuComponent implements OnInit, OnDestroy {
    private sub: Subscription;

    mainMenuItems: IMenuItem[];

    constructor(
        private readonly navigationService: NavigationService,
        private readonly locationContextService: LocationContextService
    ) {}

    ngOnInit() {
        this.loadMenuItems();

        // Subscribe to location context changes
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.sub = this.locationContextService.locationContextChanges$.subscribe(_ => this.loadMenuItems());
    }

    loadMenuItems() {
        this.mainMenuItems = this.navigationService.getMainMenuItems();
    }

    onLocationContextScreen() {
        return this.locationContextService.onLocationContextScreen();
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
